import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_4 = { class: "p-field-radiobutton" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "3thang" }, " Báo cáo 3 tháng", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "6thang" }, " Báo cáo 6 tháng", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "9thang" }, " Báo cáo 9 tháng", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "1nam" }, " Báo cáo 1 năm", -1)
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Tổng dân số trong quận/ huyện", -1)
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số hộ", -1)
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số hộ sử dụng nước từ công trình cấp nước tập trung (đơn vị cấp nước)", -1)
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Tổng số hộ gia đình sử dụng nguồn nước tự khai thác ở vùng nguy cơ ô nhiễm nguồn nước", -1)
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_21 = { class: "p-fluid" }
const _hoisted_22 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_23 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_24 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_25 = { class: "p-fluid" }
const _hoisted_26 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_27 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_28 = { class: "p-fluid" }
const _hoisted_29 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_31 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_32 = { class: "p-fluid" }
const _hoisted_33 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_34 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_35 = { class: "p-fluid" }
const _hoisted_36 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_37 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_38 = { class: "p-fluid" }
const _hoisted_39 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_40 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_41 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_42 = { class: "p-fluid" }
const _hoisted_43 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_44 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_45 = { class: "p-fluid" }
const _hoisted_46 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_47 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_48 = { class: "p-fluid" }
const _hoisted_49 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_50 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "(Vd: Tổng vệ sinh diệt bọ gây, các đợt tổng vệ sinh trong các ngày lễ lớn, các chiến dịch như Tuần lễ nước sạch & VSMT, ngày Môi trường thế giới, Ngày vệ sinh yêu nước...) Ghi cụ thể loại hoạt động và kết quả kiểm tra, số lượng người tham gia, số địa phương thực hiện... ", -1)
const _hoisted_52 = { class: "p-fluid" }
const _hoisted_53 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_54 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_55 = { class: "p-field p-col p-col-12 smbt" }
const _hoisted_56 = { class: "p-fluid" }
const _hoisted_57 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_58 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_59 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "I. Kết quả kiểm tra vệ sinh nguồn nước theo Thông tư 41/2018/TT-BYT" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "3thang",
                      name: "act",
                      value: "3thang",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baoCao.loaiBaoCao) = $event))
                    }, null, 512), [
                      [_vModelRadio, $setup.baoCao.loaiBaoCao]
                    ]),
                    _hoisted_5,
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "6thang",
                      name: "act",
                      value: "6thang",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baoCao.loaiBaoCao) = $event))
                    }, null, 512), [
                      [_vModelRadio, $setup.baoCao.loaiBaoCao]
                    ]),
                    _hoisted_6,
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "9thang",
                      name: "act",
                      value: "9thang",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.baoCao.loaiBaoCao) = $event))
                    }, null, 512), [
                      [_vModelRadio, $setup.baoCao.loaiBaoCao]
                    ]),
                    _hoisted_7,
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "1nam",
                      name: "act",
                      value: "1nam",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.baoCao.loaiBaoCao) = $event))
                    }, null, 512), [
                      [_vModelRadio, $setup.baoCao.loaiBaoCao]
                    ]),
                    _hoisted_8
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Panel, { header: "1. Thống kê sử dụng nước sạch" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createVNode(_component_InputNumber, {
                              inputId: "integeronly",
                              modelValue: $setup.baoCao.tongDanSoTrongHuyen,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.baoCao.tongDanSoTrongHuyen) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createVNode(_component_InputNumber, {
                              inputId: "integeronly",
                              modelValue: $setup.baoCao.tongSoHo,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.baoCao.tongSoHo) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createVNode(_component_InputNumber, {
                              inputId: "integeronly",
                              modelValue: $setup.baoCao.tongSoHoSuDungNuocCC,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.baoCao.tongSoHoSuDungNuocCC) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createVNode(_component_InputNumber, {
                              inputId: "integeronly",
                              modelValue: $setup.baoCao.tongSoHoSuDungNuocTuKhaiThac,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.baoCao.tongSoHoSuDungNuocTuKhaiThac) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Panel, { header: "2. Kết quả kiểm tra vệ sinh của các cơ sở cung cấp nước tập trung có công suất thiết kế dưới 1000m3/ngày đêm, các đơn vị có bể chứa nước tập trung (khu chung cư, khu tập thể, bệnh viện, trường học, doanh nghiệp, khu vực có bể chứa nước tập trung…)" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.keQuaKTVSDuoiMotNgans,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ColumnGroup, { type: "header" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Đơn vị cấp nước",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số trên địa bàn",
                                          rowspan: 2
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Ngoại kiểm",
                                          colspan: 3
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Nội kiểm",
                                          colspan: 3
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_Row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Column, {
                                          header: "Tổng số được kiểm tra, đánh giá",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số được XN mẫu nước",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số có kết quả XN đạt quy chuẩn",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số được kiểm tra, đánh giá",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số được XN mẫu nước",
                                          colspan: 1
                                        }),
                                        _createVNode(_component_Column, {
                                          header: "Tổng số có kết quả XN đạt quy chuẩn",
                                          colspan: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSo",
                                  header: "Tổng số"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createElementVNode("label", null, _toDisplayString(slotProps.data.tenDonVi), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoTrenDiaBan,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoTrenDiaBan) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soCSCoYeuToCoHai",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoDuocKTDanhGiaNgoaiKiem,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoDuocKTDanhGiaNgoaiKiem) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoDuocXNMauNuocNgoaiKiem,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoDuocXNMauNuocNgoaiKiem) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongNuCoSo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoCoKQDatQuyChuanNgoaiKiem,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCoKQDatQuyChuanNgoaiKiem) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoCoSoCoYeuTo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoDuocKTDanhGiaNoiKiem,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoDuocKTDanhGiaNoiKiem) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongNuCoSoCoYeuTo",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoDuocXNMauNuocNoiKiem,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoDuocXNMauNuocNoiKiem) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "tongSoLDTiepXucTrucTiep",
                                  header: ""
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSoCoKQDatQuyChuanNoiKiem,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSoCoKQDatQuyChuanNoiKiem) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Panel, { header: "3. Các biện pháp xử lý đối với các cơ sở không đảm bảo theo quy định:" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_Textarea, {
                              modelValue: $setup.baoCao.cacBienPhapXuLyDoiVoiCS,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.baoCao.cacBienPhapXuLyDoiVoiCS) = $event)),
                              rows: "10"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "II. Kết quả kiểm tra nhà tiêu và vệ sinh môi trường nơi công cộng" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCao.keQuaKTVSNhaVSCCs,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ColumnGroup, { type: "header" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "Loại công trình được kiểm tra",
                                rowspan: 3
                              }),
                              _createVNode(_component_Column, {
                                header: "Tổng số",
                                rowspan: 3
                              }),
                              _createVNode(_component_Column, {
                                header: "Số được K.tra",
                                rowspan: 3
                              }),
                              _createVNode(_component_Column, {
                                header: "Trong đó",
                                colspan: 4
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                header: "HVS",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Không HVS",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Đạt",
                                colspan: 1
                              }),
                              _createVNode(_component_Column, {
                                header: "Không đạt",
                                colspan: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "Tổng số"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createElementVNode("label", null, _toDisplayString(slotProps.data.loaiCongTrinh), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soTrucThuoc",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.tongSo,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soCSCoYeuToCoHai",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.soDuocKiemTra,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soDuocKiemTra) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSoCoSo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.hVS,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.hVS) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongNuCoSo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.khongHVS,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.khongHVS) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongSoCoSoCoYeuTo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.dat,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.dat) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "tongNuCoSoCoYeuTo",
                        header: ""
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            inputId: "integeronly",
                            modelValue: slotProps.data.khongDat,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.khongDat) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_Panel, { header: "2. Các biện pháp xử lý đối với các cơ sở không đảm bảo theo quy định:" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_Textarea, {
                              modelValue: $setup.baoCao.cacBienPhapXuLy,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.baoCao.cacBienPhapXuLy) = $event)),
                              rows: "10"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "III. Kết quả kiểm tra, thống kê nhà tiêu hộ gia đình" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_Panel, { header: "1. Thông tin chung" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.thongKeNhaTieuHoGiaDinhs,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "tongSo",
                                  header: "Nội dung"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createElementVNode("label", null, _toDisplayString(slotProps.data.loaiThongKe), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "Tổng số"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.tongSo,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.tongSo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_Panel, { header: "2. Chi tiết một số loại nhà tiêu" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_DataTable, {
                              value: $setup.baoCao.chiTietMotSoLoaiNhaTieu,
                              showGridlines: "",
                              rows: 40,
                              rowHover: true,
                              style: {"font-size":"14px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "tongSo",
                                  header: "Nội dung"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createElementVNode("label", null, _toDisplayString(slotProps.data.loaiNhaTieu), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "Nhà tiêu tự hoại"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.chiTiet.nhaTieuTuHoai,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiTiet.nhaTieuTuHoai) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "Nhà tiêu thấm dội nước"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.chiTiet.nhaTieuThamDoiNuoc,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiTiet.nhaTieuThamDoiNuoc) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "Nhà tiêu hai ngăn"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.chiTiet.nhaTieuHaiNgan,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiTiet.nhaTieuHaiNgan) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_Column, {
                                  field: "soTrucThuoc",
                                  header: "Nhà tiêu chìm có ống thông hơi"
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_InputNumber, {
                                      inputId: "integeronly",
                                      modelValue: slotProps.data.chiTiet.nhaTieuChimCoOngThongHoi,
                                      "onUpdate:modelValue": ($event: any) => ((slotProps.data.chiTiet.nhaTieuChimCoOngThongHoi) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "IV . Truyền thông giáo dục" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_DataTable, {
                    value: $setup.baoCao.truyenThongGiaoDucs,
                    showGridlines: "",
                    rows: 40,
                    rowHover: true,
                    style: {"font-size":"14px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "tongSo",
                        header: "Hình thức truyền  thông"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createElementVNode("label", null, _toDisplayString(slotProps.data.hinhThucTruyenThong), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soTrucThuoc",
                        header: "Nội dung truyền thông"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputText, {
                            id: "noiDungTruyenThong",
                            type: "text",
                            modelValue: slotProps.data.noiDungTruyenThong,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.noiDungTruyenThong) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soTrucThuoc",
                        header: "Số lượng(lớp,buổi,lần,...)",
                        style: {"width":"300px"}
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            modelValue: slotProps.data.soLuong,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuong) = $event),
                            inputId: "kind",
                            suffix: slotProps.data.loai,
                            min: 0
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "suffix"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soTrucThuoc",
                        header: "Đối tượng tham gia"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputText, {
                            id: "doiTuong",
                            type: "text",
                            modelValue: slotProps.data.doiTuong,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.doiTuong) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "soTrucThuoc",
                        header: "Số lượng(người,...)"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createVNode(_component_InputNumber, {
                            modelValue: slotProps.data.soLuongNguoi,
                            "onUpdate:modelValue": ($event: any) => ((slotProps.data.soLuongNguoi) = $event),
                            inputId: "temperature",
                            suffix: slotProps.data.loaiNguoi,
                            min: 0
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "suffix"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "V. Các hoạt động khác liên quan đến VSMT" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, { header: "(Báo cáo các đợt kiểm tra chung của Quận phối hợp với các chương trình khác)" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createVNode(_component_Textarea, {
                        modelValue: $setup.baoCao.cacHoatDongLienQuan,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.baoCao.cacHoatDongLienQuan) = $event)),
                        rows: "10"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "VI . Nhận xét và kiến nghị, đề xuất" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_Textarea, {
                    modelValue: $setup.baoCao.nhanXet,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.baoCao.nhanXet) = $event)),
                    rows: "10"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_Button, {
                    label: "Gởi báo cáo",
                    icon: "pi pi-upload",
                    severity: "secondary",
                    raised: "",
                    onClick: $setup.addReport
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}